import { getDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

export default async function getDropDownData () {
    const docRef = doc(db, "fields", "dropdowns");
    const docSnap = await getDoc(docRef);
    let d;
    if (docSnap.exists()) {
      d=docSnap.data();
    }
    return d
}